(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.hs-track').forEach(function (track) {
    var slides   = Array.from(track.querySelectorAll('.hs-slide'));
    var dots     = Array.from(track.querySelectorAll('.hs-dot'));
    var prevBtn  = track.querySelector('.hs-arrow--prev');
    var nextBtn  = track.querySelector('.hs-arrow--next');
    var current  = 0;
    var timer    = null;
    var autoplay = track.dataset.autoplay === 'true';
    var speed    = parseInt(track.dataset.speed, 10) || 5000;

    if (slides.length < 2) return;

    function goTo(n) {
      slides[current].classList.remove('is-active');
      if (dots[current]) { dots[current].classList.remove('is-active'); dots[current].setAttribute('aria-selected', 'false'); }
      current = ((n % slides.length) + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) { dots[current].classList.add('is-active'); dots[current].setAttribute('aria-selected', 'true'); }
    }

    function resetTimer() {
      clearInterval(timer);
      if (autoplay) timer = setInterval(function () { goTo(current + 1); }, speed);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); resetTimer(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); resetTimer(); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { goTo(parseInt(dot.dataset.index, 10)); resetTimer(); });
    });

    /* Pause on hover */
    track.addEventListener('mouseenter', function () { clearInterval(timer); });
    track.addEventListener('mouseleave', resetTimer);

    /* Touch swipe */
    var touchStartX = 0;
    track.addEventListener('touchstart', function (e) { touchStartX = e.changedTouches[0].screenX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 40) { goTo(diff > 0 ? current + 1 : current - 1); resetTimer(); }
    }, { passive: true });

    resetTimer();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.currentScript.closest('.shopify-section');
    if (!section) return;

    const grid = section.querySelector('.shop-the-look__grid');
    const dotsContainer = section.querySelector('.stl-swiper__dots');
    if (!grid || !dotsContainer) return;

    function isMobile() {
      return window.innerWidth <= 749;
    }

    function getItems() {
      return Array.from(grid.querySelectorAll('.shop-the-look__item'));
    }

    function buildDots(items) {
      dotsContainer.innerHTML = '';
      items.forEach((_, i) => {
        const dot = document.createElement('span');
        dot.className = 'stl-swiper__dot' + (i === 0 ? ' stl-swiper__dot--active' : '');
        dotsContainer.appendChild(dot);
      });
    }

    function updateDots(activeIndex) {
      const dots = dotsContainer.querySelectorAll('.stl-swiper__dot');
      dots.forEach((dot, i) => {
        dot.classList.toggle('stl-swiper__dot--active', i === activeIndex);
      });
    }

    function initSwiper() {
      if (!isMobile()) return;
      const items = getItems();
      if (items.length <= 1) return;

      buildDots(items);

      grid.addEventListener('scroll', () => {
        const scrollLeft = grid.scrollLeft;
        const itemWidth = items[0].offsetWidth + parseFloat(getComputedStyle(grid).gap);
        const activeIndex = Math.round(scrollLeft / itemWidth);
        updateDots(activeIndex);
      }, { passive: true });
    }

    // Init on load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSwiper);
    } else {
      initSwiper();
    }

    // Re-init on resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initSwiper, 200);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
